/* eslint react/prop-types: 0 */
import { FormInput } from 'camino-react'
import React from 'react'
import Select from 'react-select'
import { isEmpty } from 'lodash'

const AttributesChangedCondition = ({
  update,
  predicates = []
}) => {
  const value = () => {
    if (isEmpty(predicates)) return []
    return options.filter(option => predicates.includes(option.value))
  }

  const handleUpdate = (e) => {
    const values = e.map(attribute => attribute.value)

    update(null, values)
  }

  const options = [
    { label: 'Assignee', value: 'assignee_user_id' },
    { label: 'Chargeable', value: 'chargeable' },
    { label: 'Client', value: 'client_id' },
    { label: 'Client Contact', value: 'client_contact_id' },
    { label: 'Client Managed', value: 'client_managed' },
    { label: 'Escalation Owner', value: 'escalation_owner_id' },
    { label: 'Escalation Queue', value: 'escalation_queue_id' },
    { label: 'Needs Escalation', value: 'needs_escalation' },
    { label: 'Priority', value: 'priority_id' },
    { label: 'Service Category', value: 'service_category_id' },
    { label: 'Status', value: 'status_id' },
    { label: 'Sub Category', value: 'sub_category_id' },
    { label: 'Ticket Type', value: 'ticket_type_id' },
    { label: 'Queue', value: 'queue_id' }
  ]

  return (
    <FormInput label="Attribute">
      <Select
        options={options}
        value={value()}
        onChange={e => handleUpdate(e)}
        multi
      />
    </FormInput>
  )
}

export default AttributesChangedCondition
